export default "__VITE_ASSET__CozdzEU3__"